export function adapterForm(datos) {
    console.log('datos',datos)
    return {
        nombre: datos.nombre,
        apellido: datos.apellido,
        mail: datos.mail,
        rut: datos.rut,
        celular: datos.celular,
        id_pais_domicilio: datos.id_pais_domicilio ? datos.id_pais_domicilio : null,
        region_domicilio: datos.region_domicilio ? datos.region_domicilio : null,
        intereses: datos.intereses,
        carrera: datos.carrera? datos.carrera : null,
        universidad: datos.universidad ? datos.universidad : null,
        duracion_carrera: datos.duracion,
        especialidad: datos.especialidad, 
        ano_especialidad: datos.ano_especialidad, 
        institucion_especialidad: datos.institucion_especialidad,
        certificacion: datos.certificacion, 
        ano_certificacion: datos.ano_certificacion,
        institucion_certificacion: datos.institucion_certificacion,
        cargo_actual: datos.cargo_actual ? datos.cargo_actual : null,
        empresa_actual: datos.empresa_actual,
        id_industria_actual: datos.id_industria_actual ? datos.id_industria_actual : null,
        inicio_cargo_actual: datos.inicio_cargo_actual,
        id_industria_adicional: datos.id_industria_adicional ? datos.id_industria_adicional : null,
        cargo_adicional: datos.id_cargo_adicional ? datos.id_cargo_adicional : null,
        empresa_adicional: datos.empresa_adicional,
        inicio_cargo_adicional: datos.inicio_cargo_adicional, 
        fin_cargo_adicional: datos.fin_cargo_adicional,
        id_industria_relevante: datos.id_industria_relevante ? datos.id_industria_relevante : null,
        cargo_relevante: datos.cargo_relevante ? datos.cargo_relevante : null,
        empresa_relevante: datos.empresa_relevante,
        inicio_cargo_relevante: datos.inicio_cargo_relevante, 
        fin_cargo_relevante: datos.fin_cargo_relevante,
        id_anios_experiencia: datos.id_anios_experiencia ? datos.id_anios_experiencia : null,
        industriasExperiencia: datos.industrias ? datos.industrias.map(i => i.id) : [],
        competencias: datos.competencias ? datos.competencias.map(c => c.id) : [],
        areasExperiencia: datos.areas ? datos.areas.map(a => a.id) : [],
        tamanoEquipos: datos.tamanoEquipo,
        disponibilidad: datos.disponibilidades ? datos.disponibilidades.map(d => d.id) : [],
        id_posibilidad_cambiarse_region: datos.id_posibilidad_cambiarse_region ? datos.id_posibilidad_cambiarse_region : null,
        id_modalidad: datos.id_modalidad ? datos.id_modalidad : null,
        id_jornada: datos.id_jornada ? datos.id_jornada : null,
        disposicion_viajar: datos.disposicion_viajar === '1' ? true : datos.disposicion_viajar === '0' ? false : null,
        expectatviaRenta: datos.expectatviaRenta,
        idiomas: datos.idiomas ? datos.idiomas.map(i => i.id) : [],
        id_conocio_wot: datos.id_conocio_wot ? datos.id_conocio_wot : null,
        herramientas: datos.herramientas,
        factor: datos.factor,
        nombrePuebloOriginario: datos.nombrePuebloOriginario,
        id_region_con_compromiso: datos.id_region_con_compromiso ? datos.id_region_con_compromiso : null,
        redesSociales: datos.redesSociales,
        brief: datos.brief,
        contactos: datos.contactos,
        declaracion: datos.declaracion,        
        lenguajes: datos.lenguajes ? datos.lenguajes.map(l => l.id) : [],
        ciberSeguridad: datos.ciberseguridad === '1' ? 'Si' : datos.ciberseguridad === '0' ? 'No' : null, 
        desarrolloSoftware: datos.desarrolloSoftware === '1' ? 'Si' : datos.desarrolloSoftware === '0' ? 'No' : null,
        redes: datos.redes === '1' ? 'Si' : datos.redes === '0' ? 'No' : null,
        tecnologias: datos.tecnologias ? datos.tecnologias.map(t => t.id) : [], 
        baseDatos: datos.baseDeDatos === '1' ? 'Si' : datos.baseDeDatos === '0' ? 'No' : null, 
        tipoDb: datos.tipoDb ? datos.tipoDb.map(t => t.id) : [],
        experienciaNube: datos.experienciaNube === '1' ? 'Si' : datos.experienciaNube === '0' ? 'No' : null, 
        plataformas: datos.plataformas ? datos.plataformas.map(p => p.id) : [], 
        cultivos: datos.cultivos ? datos.cultivos.map(p => p.id) : [], 
        sistemasRiego: datos.sistemasRiego === '1' ? 'Si' : datos.sistemasRiego === '0' ? 'No' : null, 
        controlPlagas: datos.controlPlagas === '1' ? 'Si' : datos.controlPlagas === '0' ? 'No' : null, 
        plagas: datos.plagas ? datos.plagas.map(p => p.id) : [],
        certificacionAgricola: datos.certificacionAgricola === '1' ? 'Si' : datos.certificacionAgricola === '0' ? 'No' : null, 
        tecnologiasAgricolas: datos.tecnologiasAgricolas === '1' ? 'Si' : datos.tecnologiasAgricolas === '0' ? 'No' : null, 
        sistemasMecanicos: datos.sistemasMecanicosExperiencia? datos.sistemasMecanicosExperiencia.map(s => s.id): [], 
        mantenimiento: datos.experienciaMantenimiento === '0' ? 'Preventivo' : datos.experienciaMantenimiento === '1' ? 'Correctivo' : datos.experienciaMantenimiento === '2' ? 'Ambos' : null,
        fallasMecanicas: datos.fallasMecanicas === '1' ? 'Si' : datos.fallasMecanicas === '0' ? 'No' : null, 
        herramientasDiagnostico: datos.herramientasDiagnostico ? datos.herramientasDiagnostico.map(h => h.id) : [],
        equiposExperiencia: datos.equiposExperiencia ? datos.equiposExperiencia.map(e => e.id) : [],
        disenoMecanico: datos.disenoMecanico === '1' ? 'Si' : datos.disenoMecanico === '0' ? 'No' : null, 
        optimizacionProcesos: datos.optimizacionProcesos === '1' ? 'Si' : datos.optimizacionProcesos === '0' ? 'No' : null, 
        herramientasMejora: datos.herramientasMejora === '1' ? 'Si' : datos.herramientasMejora === '0' ? 'No' : null, 
        softwareGestion: datos.softwareGestion? datos.softwareGestion.map(s => s.id): [], 
        cadenaSuministro: datos.cadenaSuministro === '1' ? 'Si' : datos.cadenaSuministro === '0' ? 'No' : null, 
        gestionProyectos: datos.gestionProyectos === '1' ? 'Si' : datos.gestionProyectos === '0' ? 'No' : null, 
        tipoMineria: datos.tipoMineria? datos.tipoMineria.map(s => s.id): [], 
        mineriaPesada: datos.mineriaPesada === '1' ? 'Si' : datos.mineriaPesada === '0' ? 'No' : null, 
        softwareMinero: datos.softwareMinero? datos.softwareMinero.map(s => s.id): [], 
        procesosExtraccion: datos.procesosExtraccion === '1' ? 'Si' : datos.procesosExtraccion === '0' ? 'No' : null, 
        procesos: datos.procesos? datos.procesos.map(s => s.id): [], 
        gestionSeguridad: datos.gestionSeguridad === '1' ? 'Si' : datos.gestionSeguridad === '0' ? 'No' : null, 
     };

}